import {az} from './az'
import {en} from './en'
import {hu} from "./hu"
import {pt} from "./pt"
import {ru} from './ru'
import {tr} from './tr'
import {uz} from './uz'

import {Environment} from '../config/Environment'
import {deepMerge} from '../deepMerge'

const lang = {
  az,
  en,
  hu,
  pt,
  ru,
  tr,
  uz,
}

const envKeys = Object.keys(Environment).filter(key => key.includes('REACT_APP_TRANSLATE_'))

envKeys.forEach(envKey => {
  const code = envKey.replace('REACT_APP_TRANSLATE_', '').toLowerCase()
  try {
    const json = JSON.parse(Environment[envKey]?.replaceAll("'", '"'))
    lang[code] = deepMerge(lang[code], json)
  } catch (e) {
    //
  }
})

export function fixLanguageList(list) {
  return list.filter(l => lang[l])
}

export function fixLanguage(str) {
  const tag = str.toLocaleString()
  if (lang[tag]) {
    return tag
  }
  return Environment.REACT_APP_DEFAULT_LANGUAGE || 'en'
}

export {lang}
